import { FC, ReactNode, useState } from 'react';
import ImportDeviceDataContext from './ImportDeviceDataContext';
import { AppointmentDTO } from '@interfaces/interfaces';

interface ImportDeviceDataContextProviderProps {
  children?: ReactNode;
}

const ImportDeviceDataContextProvider: FC<ImportDeviceDataContextProviderProps> = ({
  children,
}) => {
  const [appointment, setAppointment] = useState<AppointmentDTO | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [newExamOnly, setNewExamOnly] = useState(true);

  return (
    <ImportDeviceDataContext.Provider
      value={{
        modalOpen,
        setModalOpen,
        appointment,
        setAppointment,
        newExamOnly,
        setNewExamOnly,
      }}
    >
      {children}
    </ImportDeviceDataContext.Provider>
  );
};

export default ImportDeviceDataContextProvider;
